import Vue from 'vue'
import Router from 'vue-router'
// import HelloWorld from '@/components/HelloWorld'

import Index from '@/components/Index'
import Solution from '@/components/Solution'
import NewsInform from '@/components/NewsInform'
import AboutUs from '@/components/AboutUs'
import JoinYouth from '@/components/JoinYouth'
import QingYun from '@/components/QingYun'
import CloudAssi from '@/components/CloudAssi'
import DigitalCommand from '@/components/DigitalCommand'
import OnJob from '@/components/OnJob'
import Scene from '@/components/Scene'
import NewDetail from '@/components/NewDetail'
import VideoPlatform from '@/components/VideoPlatform'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return {
      x: 0,
      y: 0
    }
  },
  routes: [{
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '青牛 | 企业智慧联络服务提供商' // 标题设置
    }
  }, {
    path: '/Solution',
    name: 'Solution',
    component: Solution
  }, {
    path: '/NewsInform',
    name: 'NewsInform',
    component: NewsInform,
    meta: {
      title: '青牛软件 | 新闻动态'
    }
  }, {
    path: '/AboutUs',
    name: 'AboutUs',
    component: AboutUs,
    meta: {
      title: '青牛软件 | 关于我们'
    }
  }, {
    path: '/JoinYouth',
    name: 'JoinYouth',
    component: JoinYouth,
    meta: {
      title: '青牛软件 | 加入我们'
    }
  }, {
    path: '/QingYun',
    name: 'QingYun',
    component: QingYun,
    meta: {
      title: '青牛软件 | 全媒体联络平台'
    }
  }, {
    path: '/CloudAssi',
    name: 'CloudAssi',
    component: CloudAssi,
    meta: {
      title: '青牛软件 | 云网助手'
    }
  }, {
    path: '/DigitalCommand',
    name: 'DigitalCommand',
    component: DigitalCommand,
    meta: {
      title: '青牛软件 | 数字指挥舱'
    }
  }, {
    path: '/VideoPlatform',
    name: 'VideoPlatform',
    component: VideoPlatform,
    meta: {
      title: '青牛软件 | 视频平台'
    }
  }, {
    path: '/OnJob',
    name: 'OnJob',
    component: OnJob,
    meta: {
      title: '青牛软件 | 在招职位'
    }
  }, {
    path: '/Scene',
    name: 'Scene',
    component: Scene,
    meta: {
      title: '青牛软件 | 解决方案'
    }
  }, {
    path: '/NewDetail/:c_id',
    name: 'NewDetail',
    component: NewDetail,
    meta: {
      title: '青牛软件 | 新闻详情'
    }
  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js